function setCookie(cname, cvalue, exdays) {
    // const d = new Date();
    // d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    // let expires = "expires="+d.toUTCString();
    // document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    localStorage.setItem(cname, cvalue);
}

function getCookie(cname) {
    return localStorage.getItem(cname)
    // let name = cname + "=";
    // let ca = document.cookie.split(';');
    // for(let i = 0; i < ca.length; i++) {
    //     let c = ca[i];
    //     while (c.charAt(0) == ' ') {
    //     c = c.substring(1);
    //     }
    //     if (c.indexOf(name) == 0) {
    //     return c.substring(name.length, c.length);
    //     }
    // }
    // return "";
}

function checkCookie() {
    let user = getCookie("username");
    if (user != "") {
        alert("Welcome again " + user);
    } else {
        user = prompt("Please enter your name:", "");
        if (user != "" && user != null) {
            setCookie("username", user, 365);
        }
    }
}
function deleteCookie(name) {
    // document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    localStorage.removeItem(name);
}

$(".open-mobile-menu").click(function () {
    $(".mobile-menu").addClass("openmobilemenu");
});

$(".mobile-menu-close").click(function () {
    $(".mobile-menu").removeClass("openmobilemenu");
});

function slidetoproducts() {
    $(".add_product svg").click(function () {
        $('html, body').animate({
            'scrollTop': $("#shopify-section-template--15637414117544__16354102941a6ae83a").position().top
        });
    });

    $(".add_product h3.addingredient").click(function () {
        $('html, body').animate({
            'scrollTop': $("#shopify-section-template--15637414117544__16354102941a6ae83a").position().top
        });
    });
}

function slidetobundle() {
    $('html, body').animate({
        'scrollTop': $(".bulk-product .right-container").position().top - 100
    });
}

function removeunwnatedcookie() {
    var product_length = 4;
    var isserum = false;
    if (window.location.pathname == '/pages/individuelles-serum') {
        product_length = 3;
        isserum = true;
    }

    for (let index = 0; index < product_length; index++) {
        if (!$($(".add_product")[index]).hasClass("added")) {
            if (isserum) {
                setCookie("product_serium_title" + index, "", 0);
                setCookie("product_serium_img" + index, "", 0);
                setCookie("product_serium_description" + index, "", 0);
                setCookie("product_serium_handle" + index, "", 0);
                setCookie("product_serium_shadow" + index, "", 0);
                setCookie("product_serium_sku" + index, "", 0);
            }
            else {
                setCookie("product_title" + index, "", 0);
                setCookie("product_img" + index, "", 0);
                setCookie("product_description" + index, "", 0);
                setCookie("product_handle" + index, "", 0);
                setCookie("product_shadow" + index, "", 0);
                setCookie("product_sku" + index, "", 0);
            }
        }
    }
};

function addlineitems() {
    var all_add_product = $(".add_product.added");
    var basecream = window.location.pathname == '/pages/individuelles-serum' ? `<input id="Standard" type="text" name="properties[Basiscreme - Serum]" value="139-500003">` : `<input id="Standard" type="text" name="properties[Basiscreme]" value="139-500003">`;
    var inputelement = basecream;
    for (let index = 0; index < all_add_product.length; index++) {
        const element = all_add_product[index];
        var name = $(element).find(".image-section").attr("data-product");
        var sku = $(element).find(".image-section").attr("data-sku");
        if (name != "") {
            inputelement = inputelement + `<input id="Wirkstoffe${index}" type="text" name="properties[${name}]" value="${sku}">`
        }

    }
    inputelement = inputelement + `<input type="text" name="properties[_referencePageLink]" value="${window.location.href}">`;
    $(".bulk-order-button form .line-items").html(inputelement);
    var variantlength = all_add_product.length;
    $("#bulk-product-select option").removeAttr("selected");
    var endpoint = 2;
    if (window.location.pathname == '/pages/individuelles-serum') {
        endpoint = 3;
    }
    if (variantlength < endpoint) {
        $(`#bulk-product-select  option[data-index="2"]`).attr('selected', 'selected');
        $(".bulk-order-button form button:last-of-type").attr("disabled", "disabled");
        $(".bulk-order-button form button:last-of-type").text("Produkte zum Warenkorb hinzufügen");
        $(".bulk-order-button form button:last-of-type").css({ "background": "#D5CEC4", "color": "#54514b" });
    }
    else if (variantlength >= endpoint) {
        $(`#bulk-product-select  option[data-index="${variantlength}"]`).attr('selected', 'selected');
        $(".bulk-order-button form button:last-of-type").removeAttr("disabled");
        var data_price = $("#bulk-product-select option:selected").attr("data-price");
        $(".bulk-order-button form button:last-of-type").text("Produkte zum Warenkorb hinzufügen");
        $(".bulk-order-button form button:last-of-type").css({ "background": "#3C4043", "color": "#fff" });
    }
}

$(".addproducttobulk").click(function () {
    if (window.location.pathname == '/pages/skin-test') {
        return;
    }
    var product_length = 4;
    var isserum = false;
    if (window.location.pathname == '/pages/individuelles-serum') {
        product_length = 3;
        isserum = true;
    }

    if ($(".add_product.added").length == product_length) {
        return;
    }

    // $(this).parent().parent().addClass("removedhere");
    var image = $(this).attr("data-image");
    var name = $(this).attr("data-name");
    var shadow = $(this).attr("data-shadow");
    var sku = $(this).attr("data-sku");
    var description = $(this).parent().parent().find(".short_description").html();
    var description_text = $(this).parent().parent().find(".short_description").text().trim();
    var datahandle = $(this).attr("data-handle");
    var all_add_product = $(".add_product");
    setTimeout(function () {
        console.log('name', name)
        $('#basecream_text').html(name + `
        <svg width="154" height="154" viewBox="0 0 154 154" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 77C0.5 34.7502 34.7502 0.5 77 0.5V0.5C119.25 0.5 153.5 34.7502 153.5 77V77C153.5 119.25 119.25 153.5 77 153.5V153.5C34.7502 153.5 0.5 119.25 0.5 77V77Z" fill="#D5CEC4"></path>
            <path d="M77 153C35.0264 153 1 118.974 1 77C1 35.0264 35.0264 1 77 1C118.974 1 153 35.0264 153 77C153 118.974 118.974 153 77 153Z" stroke="black" stroke-opacity="0.1"></path>
            <line x1="37" y1="75.5" x2="114" y2="75.5" stroke="white" stroke-width="2"></line>
            <line x1="37" y1="75.5" x2="114" y2="75.5" stroke="url(#paint0_linear_2:2)" stroke-width="2"></line>
            <line x1="76" y1="38.5" x2="76" y2="115.5" stroke="white" stroke-width="2"></line>
            <line x1="76" y1="38.5" x2="76" y2="115.5" stroke="url(#paint1_linear_2:2)" stroke-width="2"></line>
            <defs>
            <linearGradient id="paint0_linear_2:2" x1="75.5" y1="76.5" x2="75.5" y2="77.5" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"></stop>
            <stop offset="1" stop-color="white" stop-opacity="0"></stop>
            </linearGradient>
            <linearGradient id="paint1_linear_2:2" x1="75" y1="77" x2="74" y2="77" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"></stop>
            <stop offset="1" stop-color="white" stop-opacity="0"></stop>
            </linearGradient>
            </defs>
        </svg>
        <h3 class="addingredient">Wirkstoff hinzufügen</h3>
    `);
    }, 1200)
    for (let index = 0; index < all_add_product.length; index++) {
        const element = all_add_product[index];
        if (!$(element).hasClass("added")) {
            $(element).addClass("added");
            var madehtml = `
            <p class="remove-product" data-handle="${datahandle}">
                <img src="https://cdn.shopify.com/s/files/1/0517/5702/3400/files/icon-remove-white.svg?v=1636287752" />
            </p>
            <a href="/products/${datahandle}">
                <div class="image-section" data-product="${name}" data-sku="${sku}">
                    <img src="${image}" alt="">
                </div>
                <p>${name}</p>
                <div class="short_description">
                    ${description}
                </div>
            </a>`;

            if (isserum) {
                setCookie("product_serium_title" + index, "", 0);
                setCookie("product_serium_img" + index, "", 0);
                setCookie("product_serium_description" + index, "", 0);
                setCookie("product_serium_handle" + index, "", 0);
                setCookie("product_serium_shadow" + index, "", 0);
                setCookie("product_serium_sku" + index, "", 0);
                setCookie("product_serium_title" + index, name, 1);
                setCookie("product_serium_img" + index, image, 1);
                setCookie("product_serium_handle" + index, datahandle, 1);
                setCookie("product_serium_description" + index, description_text, 1);
                setCookie("product_serium_shadow" + index, shadow, 1);
                setCookie("product_serium_sku" + index, sku, 0);
            }
            else {
                setCookie("product_title" + index, "", 0);
                setCookie("product_img" + index, "", 0);
                setCookie("product_description" + index, "", 0);
                setCookie("product_handle" + index, "", 0);
                setCookie("product_shadow" + index, "", 0);
                setCookie("product_sku" + index, "", 0);
                setCookie("product_title" + index, name, 1);
                setCookie("product_img" + index, image, 1);
                setCookie("product_handle" + index, datahandle, 1);
                setCookie("product_description" + index, description_text, 1);
                setCookie("product_shadow" + index, shadow, 1);
                setCookie("product_sku" + index, sku, 0);
            }

            $(element).html(madehtml);
            break;
        }
    }
    addlineitems();
    removeit();
    removeunwnatedcookie();
    // slidetobundle();
});

slidetoproducts();

function removeit() {
    $(".remove-product").click(function () {
        var data_handle = $(this).attr("data-handle");
        $("." + data_handle).removeClass("removedhere");
        $(this).parent().removeClass("added");
        $(this).parent().html(`
        <svg width="154" height="154" viewBox="0 0 154 154" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 77C0.5 34.7502 34.7502 0.5 77 0.5V0.5C119.25 0.5 153.5 34.7502 153.5 77V77C153.5 119.25 119.25 153.5 77 153.5V153.5C34.7502 153.5 0.5 119.25 0.5 77V77Z" fill="#D5CEC4"></path>
            <path d="M77 153C35.0264 153 1 118.974 1 77C1 35.0264 35.0264 1 77 1C118.974 1 153 35.0264 153 77C153 118.974 118.974 153 77 153Z" stroke="black" stroke-opacity="0.1"></path>
            <line x1="37" y1="75.5" x2="114" y2="75.5" stroke="white" stroke-width="2"></line>
            <line x1="37" y1="75.5" x2="114" y2="75.5" stroke="url(#paint0_linear_2:2)" stroke-width="2"></line>
            <line x1="76" y1="38.5" x2="76" y2="115.5" stroke="white" stroke-width="2"></line>
            <line x1="76" y1="38.5" x2="76" y2="115.5" stroke="url(#paint1_linear_2:2)" stroke-width="2"></line>
            <defs>
            <linearGradient id="paint0_linear_2:2" x1="75.5" y1="76.5" x2="75.5" y2="77.5" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"></stop>
            <stop offset="1" stop-color="white" stop-opacity="0"></stop>
            </linearGradient>
            <linearGradient id="paint1_linear_2:2" x1="75" y1="77" x2="74" y2="77" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"></stop>
            <stop offset="1" stop-color="white" stop-opacity="0"></stop>
            </linearGradient>
            </defs>
        </svg>
        <h3 class="addingredient">Wirkstoff hinzufügen</h3>
    `);
        addlineitems();
        slidetoproducts();
        removeunwnatedcookie();
    });
}

function uploaddata() {
    var product_length = 4;
    var isserum = false;
    if (window.location.pathname == '/pages/individuelles-serum') {
        product_length = 3;
        isserum = true;
    }

    var all_add_product = $(".add_product");
    for (let index = 0; index < all_add_product.length; index++) {
        const element = all_add_product[index];
        var image = getCookie("product_img" + index);
        var name = getCookie("product_title" + index);
        var description = getCookie("product_description" + index);
        var datahandle = getCookie("product_handle" + index);
        var shadow = getCookie("product_shadow" + index);
        var sku = getCookie("product_sku" + index);

        if (isserum) {
            image = getCookie("product_serium_img" + index);
            name = getCookie("product_serium_title" + index);
            description = getCookie("product_serium_description" + index);
            datahandle = getCookie("product_serium_handle" + index);
            shadow = getCookie("product_serium_shadow" + index);
            sku = getCookie("product_serium_sku" + index);
        }
        if (!$(element).hasClass("added")) {
            if (name == "" || name == null) {
                break;
            }
            $(element).addClass("added");
            var madehtml = `
            <p class="remove-product" data-handle="${datahandle}">
            <img src="https://cdn.shopify.com/s/files/1/0517/5702/3400/files/icon-remove-white.svg?v=1636287752" />
            </p>
            <a href="/products/${datahandle}">
                <div class="image-section" data-product="${name}" data-sku="${sku}">
                    <img src="${image}" alt="">
                </div>
                <p>${name}</p>
                <div class="short_description">
                    <p>${description}</p>
                </div>
            </a>`;

            $("." + datahandle).addClass("removedhere");
            $(element).html(madehtml);
            break;
        }
    }
    addlineitems();
    removeit();
}



function addminicleanser() {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: 49508146020618
        },
        dataType: 'json',
        success: function (data) {
            document.querySelector("#product_4_product .bulk_order_form_btn").click();
        },
        error: function (responseText) {
            console.log(responseText)
            document.querySelector("#product_4_product .bulk_order_form_btn").click();
        }
    });
}



$(".bulk-order-button button").click(function () {
    localStorage.clear();
    for (let index = 0; index < 4; index++) {
        setCookie("product_title" + index, "", 0);
        setCookie("product_img" + index, "", 0);
        setCookie("product_description" + index, "", 0);
        setCookie("product_handle" + index, "", 0);
        setCookie("product_shadow" + index, "", 0);
    }


});




mobileOnlySlider(".text-block-container", true, false, 749, true);
// mobileOnlySlider(".products-here", true, false, 749, false);
if (!window.location.href.includes("https://herbsom.de/pages/skin-test")) {
    mobileOnlySlider(".bulk-order-slider .bulk-product .right-container .add-products", true, false, 749, false);
}



$(".bulk-order-slider .bulk-product .right-container .products_prev").click(function () {
    $(this).next(".add-products").find(".slick-prev").click();
});


$(".bulk-order-slider .bulk-product .right-container .products_next").click(function () {
    $(this).prev(".add-products").find(".slick-next").click();
});

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint, $autoplay) {
    var slider = $($slidername);
    var settings = {
        mobileFirst: true,
        dots: false,
        autoplay: $autoplay,
        autoplaySpeed: 1000,
        adaptiveHeight: true,
        // centerMode: true,
        responsive: [
            {
                breakpoint: $breakpoint,
                settings: "unslick"
            }
        ]
    };

    slider.slick(settings);

    $(window).on("resize", function () {
        if ($(window).width() > $breakpoint) {
            return;
        }
        if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
        }
    });
}

$(".products_prev").click(function () {
    $(this).next(".products-here").find(".slick-prev").click();
});


$(".products_next").click(function () {
    $(this).prev(".products-here").find(".slick-next").click();
});


$(".featured_products_sliders").slick({
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});

$(".product_slider_next").click(function () {
    $(this).prev(".featured_products_sliders").find(".slick-next").click();
});

$(".product_slider_prev").click(function () {
    $(this).next(".featured_products_sliders").find(".slick-prev").click();
});

function changesliderscal() {
    if (screen.width > 768) {
        var leng = $(".active_ingredient_loop.slick-slide.slick-active");
        $(".active_ingredient_loop").css({ "transform": "Scale(1)", "left": "0px" });
        $(leng[1]).css({ "transform": "Scale(1)", "left": "25px" });
        $(leng[0]).css({ "transform": "Scale(.55)", "left": "0px" });
        $(leng[2]).css({ "transform": "Scale(.55)", "left": "0px" });
        // $(leng[1]).css("transform", "Scale(.70)");
        // $(leng[3]).css("transform", "Scale(.70)");
    }
}

$(".active_ingredient_next").click(function () {
    $(this).prev(".active_ingredients_loop").find(".slick-next").click();
    changesliderscal();
});


$(".active_ingredient_prev").click(function () {
    $(this).next(".active_ingredients_loop").find(".slick-prev").click();
    changesliderscal();
});

$(document).ready(function () {
    changesliderscal();
});


if (document.getElementsByClassName("active_ingredients_loop").length > 0) {
    document.getElementsByClassName("active_ingredients_loop")[0].addEventListener("ondrag", function () {
        changesliderscal();
        const slider = document.querySelector('.active_ingredients_loop');
        // window.scroll2 = 0;
        let mouseDown = false;

        let startDragging = function (e) {
            e.preventDefault();
            mouseDown = true;


            changesliderscal();
            console.log("akj")
        };

        let stopDragging = function (event) {
            event.preventDefault();
            mouseDown = false;
            changesliderscal();
            console.log("akj")
        };

        slider.addEventListener('mousedown', (e) => startDragging(e), false);
        slider.addEventListener('mouseup', (e) => stopDragging(e), false);
        slider.addEventListener('mouseleave', (e) => stopDragging(e), false);
    });
}


$(".bundleaddtocart").click(function (e) {
    e.preventDefault();
    var form = $(this).parent();
    form.submit()
})


function cartscriptskin(form) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: form.serialize(),
        dataType: 'json',
        success: function (data) {
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function (data) {
                    $("#cart_count").text(data.item_count);
                    alert("Das Produkt wird in den Warenkorb gelegt");
                },
                error: function (responseText) {
                    console.log(responseText);
                }
            });
        },
        error: function (responseText) {
            console.log(responseText)
        }
    });
}


$(".skin-problem-bulk-edit .main-skin-btn-add").click(function (e) {
    // if (window.location.pathname == '/products/erstelle-deine-creme') {
    //     addminicleanser()
    // }
    e.preventDefault();
    var form = $(this).parent('form');

    cartscriptskin(form);
})

$(".custom-form input.btn").click(function (e) {
    e.preventDefault();

    var form = $(this).closest("form");

    cartscriptskin(form);
});

$(".ajaxaddtocart").click(function (e) {
    e.preventDefault();
    var form = $(this).parent('form');
    cartscriptskin(form);
})


document.querySelectorAll(".skin-problem-bulk-edit .add_product a").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
        var title = this.getAttribute("data-title")
        e.preventDefault();
        document.querySelector(".skin-problem-bulk-edit-popup-title").textContent = title;
        var url = this.getAttribute("href")
        fetch(url).then(function (response) {
            // The API call was successful!
            return response.text();
        }).then(function (html) {
            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            document.querySelector('.problem-poup-product-data-container').innerHTML = doc.querySelector("#MainContent").innerHTML;
            document.querySelector(".skin-problem-bulk-edit-popup").classList.add("active");
        }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
        });

    })
})

function sliders() {
    $(".product-image-with-text-container-main").slick({
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    });



    $(".product-image-with-text-container .right-container .prev-button-slider").click(function () {
        $(".product-image-with-text-container-main").find(".slick-prev").click();
    });

    $(".product-image-with-text-container .right-container .next-button-slider").click(function () {
        $(".product-image-with-text-container-main").find(".slick-next").click();
    });
}

document.querySelectorAll(".product-here a").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
        var title = this.getAttribute("data-title")
        e.preventDefault();
        document.querySelector(".skin-problem-bulk-edit-popup-title").textContent = title;
        var url = this.getAttribute("href")
        fetch(url).then(function (response) {
            // The API call was successful!
            return response.text();
        }).then(function (html) {
            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            document.querySelector('.problem-poup-product-data-container').innerHTML = doc.querySelector("#MainContent").innerHTML;
            document.querySelector(".skin-problem-bulk-edit-popup").classList.add("active");
            sliders()
        }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
        });

    })
})

document.querySelector(".skin-popup-close").addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector(".skin-problem-bulk-edit-popup").classList.remove("active");
})

document.querySelectorAll(".popupwindow").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
        var title = this.getAttribute("data-title")
        e.preventDefault();
        document.querySelector(".skin-problem-bulk-edit-popup-title").textContent = title;
        var url = this.getAttribute("href")
        fetch(url).then(function (response) {
            // The API call was successful!
            return response.text();
        }).then(function (html) {
            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            document.querySelector('.problem-poup-product-data-container').innerHTML = doc.querySelector("#MainContent").innerHTML;
            document.querySelector(".skin-problem-bulk-edit-popup").classList.add("active");
            sliders()
        }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
        });

    })
})

$(".add_all_products").click(function (e) {
    e.preventDefault();
    console.log('ifff')
    var all_btn = $(this)
    all_btn.text(all_btn.attr("data-text-add"));
    all_btn.attr("disabled", "disabled");
    var items = $("#product_4_product .line-items input");
    // $("#product_4_product .line-items").html("");
    var form = $("#product_4_product form");

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: form.serialize(),
        dataType: 'json',
        success: function (data) {
            var items = $("#product_3_product .line-items input");
            // $("#product_3_product .line-items").html("");
            var form = $("#product_3_product form");
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: form.serialize(),
                dataType: 'json',
                success: function (data) {

                    var form = $("#reiniger_product form")
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: form.serialize(),
                        dataType: 'json',
                        success: function (data) {

                            var form = $("#reiniger_product2 form");
                            $.ajax({
                                type: 'POST',
                                url: '/cart/add.js',
                                data: form.serialize(),
                                dataType: 'json',
                                success: function (data) {
                                    
                                    var form = $("#reiniger_product3 form");
                                    $.ajax({
                                        type: 'POST',
                                        url: '/cart/add.js',
                                        data: form.serialize(),
                                        dataType: 'json',
                                        success: function (data) {
                                          $.ajax({
                                                type: 'GET',
                                                url: '/cart.js',
                                                dataType: 'json',
                                                success: function (data) {
                                                    $("#cart_count").text(data.item_count);
                                                    all_btn.text(all_btn.attr("data-text"));
                                                    all_btn.removeAttr("disabled");
                                                    alert("Das Produkt wird in den Warenkorb gelegt");
                                                },
                                                error: function (responseText) {
                                                    console.log(responseText);
                                                }
                                            });  
                                        },
                                        error: function (responseText) {
                                            console.log(responseText)
                                        }
                                    });
                                },
                                error: function (responseText) {
                                    console.log(responseText)
                                }
                            });

                        },
                        error: function (responseText) {
                            console.log(responseText)
                        }
                    });
                },
                error: function (responseText) {
                    console.log(responseText)
                }
            });
        },
        error: function (responseText) {
            console.log(responseText)
        }
    });
})